import { create } from 'zustand';

export const usePricing = create((set, get) => ({
  // Config
  storage_gb: 250,
  collabora_users: 0,
  antivirus: false,
  hp_backend: false,
  
  // Prices from backend (loaded dynamically via /api/config/pricing)
  prices: null,
  pricesLoaded: false,

  // Preis-Breakdown
  breakdown: null,
  loading: false,
  error: null,

  // Actions
  setStorageGb: (value) => set({ storage_gb: value }),
  setCollaboraUsers: (value) => set({ collabora_users: value }),
  setAntivirus: (value) => set({ antivirus: value }),
  setHpBackend: (value) => set({ hp_backend: value }),

  // Fetch all prices from backend
  fetchPrices: async () => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const response = await fetch(`${backendUrl}/api/config/pricing`);
      if (response.ok) {
        const data = await response.json();
        set({ 
          prices: {
            base_price: data.base_price,
            storage_extra_50gb: data.storage_extra_50gb,
            collabora_per_user: data.collabora_per_user,
            antivirus: data.antivirus,
            hp_backend: data.hp_backend,
            storage_base_gb: data.storage_base_gb || 250,
            storage_step_gb: data.storage_step_gb || 50
          },
          pricesLoaded: true
        });
        return data;
      }
    } catch (error) {
      console.error('Failed to fetch prices:', error);
    }
    return null;
  },

  // Calculate Price
  calculatePrice: async () => {
    const { storage_gb, collabora_users, antivirus, hp_backend } = get();
    set({ loading: true, error: null });

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const response = await fetch(`${backendUrl}/api/pricing/quote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ storage_gb, collabora_users, antivirus, hp_backend })
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.detail || 'Preisberechnung fehlgeschlagen');
      }

      set({ breakdown: data, loading: false });
      return data;
    } catch (error) {
      set({ error: error.message, loading: false, breakdown: null });
      console.error('Pricing calculation error:', error);
      return null;
    }
  },

  // Reset to defaults
  reset: () => set({
    storage_gb: 250,
    collabora_users: 0,
    antivirus: false,
    hp_backend: false,
    breakdown: null,
    error: null
  })
}));
